import React from 'react';
import styles from './Divider.Thin.scss';
export var DividerThin = function DividerThin() {
  return React.createElement("hr", {
    className: styles.dividerThin
  });
};